<template>
  <div>
    <Header></Header>
    <div v-if="menu">
      <div class="back-button">
        <router-link to="/admin/calendar"
          ><i class="go-back-button" v-if="$auth.isUserLogged"></i
        ></router-link>
      </div>
      <h4>{{ menuDate("es") }} / {{ menuDate("eu") }}</h4>
      <div class="menu">
        <section class="starters">
          <h3>Empezamos con... / Hasteko...</h3>
          <div class="plate-group">
            <template v-for="(starter, index) in menu.starters" class="plate">
              <div :key="`${index}-text`" class="plate-text">
                {{ starter.text }}
              </div>
              <div :key="`${index}-allergens`" class="plate-allergens">
                <img
                  v-for="allergen in starter.allergens"
                  :key="allergen"
                  :src="require(`@/assets/icons/allergens/${allergen}.svg`)"
                />
              </div>
            </template>
          </div>
        </section>

        <section class="mains">
          <h3>Continuamos con... / Jarraitzeko...</h3>
          <div class="plate-group">
            <template v-for="(main, index) in menu.mains" class="plate">
              <div :key="`${index}-text`" class="plate-text">
                {{ main.text }}
              </div>
              <div :key="`${index}-allergens`" class="plate-allergens">
                <img
                  v-for="allergen in main.allergens"
                  :key="allergen"
                  :src="require(`@/assets/icons/allergens/${allergen}.svg`)"
                  alt=""
                />
              </div>
            </template>
          </div>
        </section>

        <section class="economics">
          <h3>Menú Boluetabarri / Boluetabarri menua</h3>
          <div class="plate-group">
            <template v-for="(economic, index) in menu.economic" class="plate">
              <div :key="`${index}-text`" class="plate-text">
                {{ economic.text }}
              </div>
              <div :key="`${index}-allergens`" class="plate-allergens">
                <img
                  v-for="allergen in economic.allergens"
                  :key="allergen"
                  :src="require(`@/assets/icons/allergens/${allergen}.svg`)"
                />
              </div>
            </template>
          </div>
        </section>

        <section class="desserts">
          <h3>Postres / Postreak</h3>
          <div class="plate-group">
            <template v-for="(dessert, index) in menu.desserts" class="plate">
              <div :key="`${index}-text`" class="plate-text">
                {{ dessert.text }}
              </div>
              <div :key="`${index}-allergens`" class="plate-allergens">
                <img
                  v-for="allergen in dessert.allergens"
                  :key="allergen"
                  :src="require(`@/assets/icons/allergens/${allergen}.svg`)"
                />
              </div>
            </template>
          </div>
        </section>
      </div>
    </div>
    <div>
      <section class="prices">
        <h3>Precios / Prezioak</h3>
        <div class="price-container">
          <!--
            <div class="price-box">
              <div class="price-box-text">Menú del día de 13:00 a 13:30</div>
              <div class="price-box-price">{{ prices.menuDiaPronto }}</div>
            </div>
          <div class="price-box">
            <div class="price-box-text">Menú Boluetabarri sin vino</div>
            <div class="price-box-price">{{ prices.menuEconomico }}</div>
          </div>
          -->
          <div class="price-box">
            <div class="price-box-text">Menú Boluetabarri</div>
            <div class="price-box-price">
              {{ prices.menuEconomico }}
            </div>
          </div>
          <div class="price-box">
            <div class="price-box-text">Menú del día con pan, vino y agua</div>
            <div class="price-box-price">{{ prices.menuDia }}</div>
          </div>
          <div class="price-box">
            <div class="price-box-text">
              Menú express: 1º con postre o café (con agua)
            </div>
            <div class="price-box-price">{{ prices.menuExpressPrimero }}</div>
          </div>
          <div class="price-box">
            <div class="price-box-text">
              Menú express: 2º con postre o café (con agua)
            </div>
            <div class="price-box-price">{{ prices.menuExpressSegundo }}</div>
          </div>
        </div>
      </section>
    </div>
    <div class="allergens-wrapper">
      <h3>Alérgenos</h3>
      <div class="allergens">
        <img src="~@/assets/allergens-1.png" />
        <img src="~@/assets/allergens-2.png" />
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/views/_common/Header.vue";
import api from "@/services/api";
export default {
  name: "Menu",
  components: {
    Header,
  },
  methods: {
    async getTodaysMenu() {
      this.menu = await api.getTodaysMenu();
      console.log(this.menu);
    },
    async getMenuByDate() {
      const date = this.$route.params.date;
      this.menu = await api.getMenuByDate(date);
      console.log(this.menu);
    },
    menuDate(lang) {
      const d = new Date(this.menu.date);
      return d.toLocaleString(lang, {
        day: "numeric",
        year: "numeric",
        month: "short",
      });
    },
  },
  data() {
    return {
      menu: null,
      prices: window.config.prices,
    };
  },
  computed: {},
  async created() {
    const arg = this.$route.params.date;
    if (!arg) {
      await this.getTodaysMenu();
    } else {
      await this.getMenuByDate();
    }
  },
};
</script>

<style scoped>
.menu {
  padding: 0 2rem;
}

.plate-allergens img {
  width: 30px;
  margin: 0 5px;
}

.plate-group {
  display: grid;
  grid-template-columns: 2fr 1fr;
  grid-row-gap: 1em;
  grid-column-gap: 1em;
}

.plate-allergens {
  text-align: right;
}

.plate {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
}

h3,
h4 {
  text-align: center;
}
h3:before {
  content: "\2015\2015\2015\2015 \00a0";
}

h3:after {
  content: "\00a0 \2015\2015\2015\2015";
}

.price-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  max-width: 70%;
  margin: auto;
}

.price-box {
  background: white;
  padding: 1rem;
  box-shadow: 6px 10px 10px -6px rgba(0, 0, 0, 0.07);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.price-box-text {
  font-size: 0.98rem;
  font-weight: bold;
  color: #272727;
  text-align: center;
}

.price-box-price {
  color: #ff3c3c;
  text-align: center;
  font-weight: bold;
  font-size: 1.5rem;
  margin-top: 0.4rem;
}
.go-back-button {
  height: 40px;
  width: 40px;
  background-image: url("~@/assets/go-back-button.png");
  background-size: cover;
  display: inline-block;
  float: left;
}

.allergens-wrapper {
  display: flex;
  flex-direction: column;
  padding: 50px 0;
}

.allergens {
  display: flex;
  justify-content: center;
}

.allergens img {
  max-width: 350px;
}

@media print {
  div {
    float: none !important;
    position: static !important;
    display: inline;
    box-sizing: content-box !important;
  }
}
@media print {
  div.price-container {
    margin-left: 0 auto;
    max-width: 100%;
    gap: 0.25rem;
  }
  div.price-container .price-box-text {
    font-size: 0.85rem;
  }
  div.price-container .price-box-price {
    font-size: 1.15rem;
  }
  section {
    break-inside: avoid-page;
  }
  section.economics {
    break-after: page;
  }
}

@media only screen and (max-width: 785px) {
  .price-container {
    grid-template-columns: 1fr 1fr;
    gap: 1.5rem;
  }
  .allergens {
    flex-direction: column;
  }
  .allergens img {
    margin: 0 auto;
  }
}

@media only screen and (max-width: 490px) {
  h4,
  h3 {
    font-size: 1rem;
  }
  h3:before {
    content: " \2015\2015\2015 \00a0  ";
  }

  h3:after {
    content: " \00a0 \2015\2015\2015";
  }

  .price-container {
    grid-template-columns: 1fr;
  }

  .plate-text {
    font-size: 0.9rem;
  }

  .price-box {
    min-height: 100px;
    display: flex;
    align-items: center;
  }

  .plate-allergens img {
    width: 25px;
    margin: 0 3px;
  }

  .allergens img {
    max-width: 320px;
  }
}

@media only screen and (max-width: 360px) {
  h3:before {
    content: " \2015\2015 \00a0  ";
  }

  h3:after {
    content: " \00a0 \2015\2015";
  }

  .plate-allergens img {
    width: 20px;
    margin: 0 2.5px;
  }

  .allergens img {
    max-width: 250px;
  }
}
</style>
